import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-no-connection',
  templateUrl: './no-connection.component.html',
  styleUrls: ['./no-connection.component.scss'],
})
export class NoConnectionComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  goToHomePage(): void {
    this.router.navigate(['roadtrips']);
  }
}
